//* Libraries Imports
import moment from "moment";

function InfoAvaliacaoPanel({ inscricao, renderCampo }) {
  return (
    <>
      <h5 style={{ color: "black", marginTop: 10, marginBottom: 10 }}>
        Informações de Avaliação
      </h5>
      {renderCampo("Observações da Avaliação", inscricao.observacoesAvaliacao)}
      {renderCampo("Data da Avaliação", inscricao.dataAvaliacao, {
        transform: (v) => (v ? moment(v).format("DD/MM/YYYY HH:mm") : "-"),
      })}
      <div style={{ marginBottom: 10 }}>
        <b style={{ color: "black" }}>Avaliador: </b>
        <span>{inscricao.avaliador?.name || "-"}</span>
      </div>
      <div style={{ marginBottom: 10 }}>
        <b style={{ color: "black" }}>Faculdade: </b>
        <span>{inscricao.faculdade?.name || "-"}</span>
      </div>
      <div style={{ marginBottom: 10 }}>
        <b style={{ color: "black" }}>Processo: </b>
        <span>{inscricao.processo?.name || "-"}</span>
      </div>
      <div className="row" style={{ marginTop: 10 }}>
        <div className="col-md-6">
          {renderCampo("Criado em", inscricao.createdAt, {
            transform: (v) =>
              v && moment(v).isValid()
                ? moment(v).format("DD/MM/YYYY HH:mm")
                : "-",
          })}
        </div>
        <div className="col-md-6">
          {renderCampo("Atualizado em", inscricao.updatedAt, {
            transform: (v) =>
              v && moment(v).isValid()
                ? moment(v).format("DD/MM/YYYY HH:mm")
                : "-",
          })}
        </div>
      </div>
    </>
  );
}

export default InfoAvaliacaoPanel;